import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { notificationMatchesActiveContext } from '../../lib/notifications/matchesActiveContext'
import { useMarkNotificationRead, usePersonalNotifications } from './useNotifications'

/**
 * Auto-mark unread personal notifications as read when the user is already
 * on that notification's deep_link (same module path + flow id).
 *
 * Keeps the bell quiet for in-progress work the user is watching, without
 * deleting the inbox row (history + deep link remain if they leave).
 */
export function useAutoReadVisibleNotifications(enabled: boolean) {
  const { pathname, search } = useLocation()
  const { data: items } = usePersonalNotifications(enabled)
  const { mutateAsync } = useMarkNotificationRead()
  const inFlight = useRef(new Set<number>())

  useEffect(() => {
    if (!enabled || !items?.length) return

    for (const item of items) {
      if (item.read_at) continue
      if (inFlight.current.has(item.id)) continue
      if (
        !notificationMatchesActiveContext(item.payload.deep_link, pathname, search)
      ) {
        continue
      }

      inFlight.current.add(item.id)
      void mutateAsync(item.id).finally(() => {
        inFlight.current.delete(item.id)
      })
    }
  }, [enabled, items, pathname, search, mutateAsync])
}
